@if (space(); as spaceWidget) {
  <div class="h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="flex flex-col">
        <span class="text-sm text-ui-dark mb-2">Status:</span>
        <app-entity-status
          [status]="spaceWidget.status"
          fontSize="base"
          fontWeight="medium"
        />
      </div>

      <div class="flex">
        <div>
          <span class="text-sm text-ui-dark mb-2">Incidents:</span>
          <div class="flex">
            <avs-incident-severity-count
              [critical]="spaceWidget.incidentCountBySeverity.critical"
              [major]="spaceWidget.incidentCountBySeverity.major"
              [minor]="spaceWidget.incidentCountBySeverity.minor"
              showZero
            />
          </div>
        </div>

        <span class="border-r border-ui-gray-light mx-4 my-2"></span>

        <div>
          <span class="text-sm text-ui-dark mb-2">Devices:</span>
          <div>
            @if (spaceWidget.devicesByStatuses) {
              <avs-status-count
                [active]="spaceWidget.devicesByStatuses.activeCount"
                [paused]="spaceWidget.devicesByStatuses.pausedCount"
              />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <ngx-skeleton-loader [theme]="{ height: '100%' }" />
}
